<!-- eslint-disable implicit-arrow-linebreak -->
<template>
    <div v-show="iosQRCode" class="flex justify-evenly">
        <div class="m-4" v-if="props.showAndroid">
            <div class="mt-2 flex flex-col items-center font-semibold text-xl">
                <a :href="Config.googlePlayConfig.appUrl">
                    <img class="w-[150px]" src="@/assets/img/Google-play-icon-1920w.webp" alt="Download on the Play Store" />
                </a>
            </div>
            <div class="flex justify-center font-semibold text-xl">
                <img class="w-[150px] h-[150px]" :src="androidQRCode" alt="QR code for Android app">
            </div>
        </div>
        <div class="m-4" v-if="props.showIos">
            <div class="mt-2 flex flex-col items-center font-semibold text-xl">
                <a :href="Config.iosConfig.appUrl">
                    <img class="w-[150px]" src="@/assets/img/app-store-badge-1920w.webp" alt="Download on the App Store" />
                </a>
            </div>
            <div class="flex justify-center font-semibold text-xl">
                <img class="w-[150px] h-[150px]" :src="iosQRCode" alt="QR code for iOS app">
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import useQRCode from "@/modules/useQRCode";
import Config from "@/config/Config";

interface Props {
    showIos: boolean;
    showAndroid: boolean;
}

const props = defineProps<Props>();

const { generateQRCode } = useQRCode();
const androidQRCode = ref<string>();
const iosQRCode = ref<string>();

const initalize = async () => {
    androidQRCode.value = await generateQRCode(Config.googlePlayConfig.appUrl);
    iosQRCode.value = await generateQRCode(Config.iosConfig.appUrl);
};

initalize();
</script>
